<template>
  <div class="element-processor-step" v-if="isVisible">
    <slot />
  </div>
</template>
<script>
export default {
  props: ["data", "type"],
  data(){
    return {
      isVisible: false,
      proxy_data: null
    }
  },
  watch: {
    'isVisible' (n) {
      if(n && this.type != 'simple') {
        if(!this.$route.query.procstep || this.data.title != this.$route.query.procstep){
          var tab = this.$route.query.tab;
          var event = this.$route.query.event; // 2022-02-04 이벤트 쿼리스트링
          let query = { 
            tab : tab, 
            procstep: this.data.title,
            event: event,
          };

          if (this.$route.query.c_id) {
            query.c_id = this.$route.query.c_id;
          }

          if (this.$route.query.t) {
            query.t = this.$route.query.t;
          }

          if (this.$route.query.r_id) {
            query.r_id = this.$route.query.r_id;
          }
                    
          this.$router.replace({ query });
        }
      }
    }
  }
}
</script>
